export let ReadOnlyReason = /*#__PURE__*/function (ReadOnlyReason) {
  ReadOnlyReason["Anonymous"] = "anonymous";
  ReadOnlyReason["Unlicensed"] = "unlicensed";
  return ReadOnlyReason;
}({});